import Hero from "../designSystem/Hero";
// import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import MortgageOverpaymentCalculator from "./calculators/OverpaymentCalculator";
import SEO from "../designSystem/SEO";

const MortgageOverpaymentCalculatorsPage = () => {
  return (
    <div>
      <SEO
        title="Mortgage Overpayment Calculator"
        description="See how regular mortgage overpayments could reduce your balance, interest costs and mortgage term with our overpayment calculator."
        path="/calculators/mortgage-overpayment"
      />
      <Hero
        //         title={`Financial Clarity
        // Direction & Confidence`}
        //         subtitle="Wealth Management Solutions"
        showOverlay={true}
        // backgroundImage={HeroBackground}
        titleAlign="center"
        subtitleAlign="center"
        pageTitle="Calculators"
        title="Mortgage Overpayment"
        subtitle="
Making overpayments on your mortgage could help you reduce the amount of interest you pay and potentially pay off your mortgage sooner. Our Mortgage Overpayment Calculator helps you see how making additional payments could affect your mortgage balance, interest costs and overall mortgage term."
        showButton={true}
        textAlign="center"
      ></Hero>
      <MortgageOverpaymentCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default MortgageOverpaymentCalculatorsPage;
